import React from 'react';
import PropTypes from 'prop-types';
import I18nContext from './i18n-context';
import getTranslateFunction from './getTranslateFunction';

class I18nProvider extends React.Component {
  constructor(props) {
    super(props);

    this.setLanguage = (lang) => {
      this.setState({
        lang,
      });
    };

    this.setTranslations = (translations, languageOrOptions) => {
      const options = typeof languageOrOptions === 'string' ? { language: languageOrOptions } : languageOrOptions || {};
      const { language, preserveExisting } = options;
      const trans = { ...this.state.translations };
      const newTranslations = language === undefined ? translations : { ...trans, [language]: translations };
      this.updateTranslations(preserveExisting ? Object.keys(newTranslations).reduce(
        (allTranslations, lang) => ({
          ...allTranslations,
          [lang]: {
            ...allTranslations[lang],
            ...newTranslations[lang],
          },
        }),
        trans,
      ) : newTranslations);
    };

    this.updateTranslations = (translations) => {
      this.setState({
        translations,
      });
    };

    this.translateFn = (key, params, comment) => getTranslateFunction(this.state.translations, this.state.lang, this.state.fallbackLang)(key, params, comment);

    this.getLanguage = () => this.state.lang;

    this.state = {
      lang: 'en',
      translations: { en: {} },
      fallbackLang: 'en',
      setTranslations: this.setTranslations,
      setLanguage: this.setLanguage,
      t: this.translateFn,
      getCurrentLanguage: this.getLanguage,
    };
  }

  render() {
    return (
      <I18nContext.Provider value={this.state}>
        {this.props.children}
      </I18nContext.Provider>
    );
  }
}

I18nProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default I18nProvider;



// WEBPACK FOOTER //
// ./src/i18n/i18n-provider.js